import type { Dispatch } from "react";
import type { EditorAction } from "../../editor/reducers";
import { ArtifactRegionTypeCard } from "../artifact/ArtifactRegionTypeCard";
import { CaptionRegionTypeCard } from "../caption/CaptionRegionTypeCard";
import { FigureRegionTypeCard } from "../figure/FigureRegionTypeCard";
import { FormulaRegionTypeCard } from "../formula/FormulaRegionTypeCard";
import { HeadingRegionTypeCard } from "../heading/HeadingRegionTypeCard";
import { ImageRegionTypeCard } from "../image/ImageRegionTypeCard";
import { ListRegionTypeCard } from "../list/ListRegionTypeCard";
import { ListItemRegionTypeCard } from "../list-item/ListItemRegionTypeCard";
import { SublistRegionTypeCard } from "../sublist/SublistRegionTypeCard";
import { TableRegionTypeCard } from "../table/TableRegionTypeCard";
import { TextRegionTypeCard } from "../text/TextRegionTypeCard";
import { TOCRegionTypeCard } from "../toc/TOCRegionTypeCard";
import { HybridRegionTypeCard } from "../hybrid/HybridRegionTypeCard";
import { assertTypeName } from "../../client/guards";
import { useUntypedRegionEditorSuspenseQuery } from "../../client/generated";

type Props = {
  regionId: string;
  dispatch: Dispatch<EditorAction>;
};

export function UntypedRegionEditor({ regionId, dispatch }: Props) {
  const { data } = useUntypedRegionEditorSuspenseQuery({
    variables: { regionId },
  });

  const { region } = data;
  assertTypeName(region?.__typename === "Region");

  return (
    <div className="flex flex-col p-4 gap-4">
      <HeadingRegionTypeCard fragment={region} dispatch={dispatch} />
      <TextRegionTypeCard fragment={region} dispatch={dispatch} />
      <FormulaRegionTypeCard fragment={region} dispatch={dispatch} />

      <TableRegionTypeCard fragment={region} dispatch={dispatch} />
      <ImageRegionTypeCard fragment={region} dispatch={dispatch} />
      <FigureRegionTypeCard fragment={region} dispatch={dispatch} />
      <CaptionRegionTypeCard fragment={region} dispatch={dispatch} />

      <ListRegionTypeCard fragment={region} dispatch={dispatch} />
      <ListItemRegionTypeCard fragment={region} dispatch={dispatch} />
      <SublistRegionTypeCard fragment={region} dispatch={dispatch} />

      <ArtifactRegionTypeCard fragment={region} dispatch={dispatch} />
      <TOCRegionTypeCard fragment={region} dispatch={dispatch} />
      <HybridRegionTypeCard fragment={region} dispatch={dispatch} />
    </div>
  );
}
